import { ArrowDown } from "lucide-react";
import { CitationsCarousel } from "~/modules/billing/components/CitationsCarousel";
import { User, PlanTypes } from "~/modules/user/store/types";
import { MediaCitation } from "~/modules/media_citations/types";
import { PlanCards } from "./PlanCards";
import {
    COMPARE_PLANS_SECTION_ID,
    ComparePlansTable,
} from "./ComparePlansTable";
import { PageHeader } from "~/components/PageHeader";

// // // //

export function PricingPage(props: {
    user?: User | null;
    isLoggedIn: boolean;
    citations: MediaCitation[];
}) {
    const { user, isLoggedIn, citations } = props;

    // Get the plan type of the current user's organization
    const planType = user?.organization?.plan?.type ?? PlanTypes.FREE;

    // Check if the current user is an owner or admin of the current organization
    const isOwnerOrAdmin = ["OWNER", "ADMIN"].includes(
        user?.memberships.find((m) => m.organizationID === user.organization.id)
            ?.role ?? "",
    );

    // Public organization ID for the current user's organization
    const organizationID = user?.organization.id ?? "";

    // antialiased - interesting!
    // isolate - what does this do?
    return (
        <>
            <PageHeader
                title="Plans &amp; pricing"
                subtitle="Access tokenized asset data through the platform, downloads, MCP, and API. Choose the plan that fits your work."
            />

            <div className="mb-5 text-base sm:text-sm">
                <a
                    href={`#${COMPARE_PLANS_SECTION_ID}`}
                    className="inline-flex items-center gap-2 font-medium text-link underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-ring"
                >
                    Compare all features{" "}
                    <ArrowDown className="size-4 shrink-0" aria-hidden="true" />
                </a>
            </div>

            <PlanCards
                isLoggedIn={isLoggedIn}
                planType={planType}
                isOwnerOrAdmin={isOwnerOrAdmin}
                organizationID={organizationID}
            />

            <CitationsCarousel citations={citations} />

            <ComparePlansTable />
        </>
    );
}
